// Pin — handdrawn-style map pin SVG with optional label.
// Ported from design-canon/project/src/components.jsx → Pin

import type { CSSProperties } from 'react'

export type PinSpec = {
  x: number
  y: number
  color?: string
  label?: string
  size?: 'md' | 'lg'
}

export function Pin({
  color = 'var(--orange)',
  label,
  size = 'md',
  style,
  testid,
  dataX,
  dataY,
}: {
  color?: string
  label?: string
  size?: 'md' | 'lg'
  style?: CSSProperties
  testid?: string
  dataX?: number
  dataY?: number
}) {
  return (
    <span
      className={`pin ${size === 'lg' ? 'lg' : ''}`}
      style={style}
      aria-hidden
      data-testid={testid}
      data-x={dataX}
      data-y={dataY}
    >
      <svg viewBox="0 0 44 54">
        <title>Map pin</title>
        <path
          d="M22 2c-9 0-16 6.5-16 15.5C6 28 22 50 22 50s16-22 16-32.5C38 8.5 31 2 22 2z"
          fill={color}
          stroke="var(--line)"
          strokeWidth="2.5"
        />
        <circle cx="22" cy="18" r="6" fill="var(--paper)" stroke="var(--line)" strokeWidth="2" />
      </svg>
      {label ? <span className="label">{label}</span> : null}
    </span>
  )
}
